import { Card, Cards, Container, Content } from "./styles";

import Image1 from "../../images/image.png";
import Image2 from "../../images/bussiness-people-working-team-office.png";
import Image3 from "../../images/lawyer-legal-counsel-presents-client-signed-contract-with-gavel-legal-law-justice-lawyer-business-partnership-meeting-concept.png";
import Image4 from "../../images/smiling-female-manager-eyeglasses-with-documents-hands.png";

const Benefits = () => {
  return (
    <Container>
      <Content>
        <h1>Na Cassavia Advocacia você encontra:</h1>

        <Cards>
          <Card>
            <img src={Image1} alt="imagem" />
            <h3>Atendimento claro, humano e acolhedor</h3>
          </Card>
          <Card>
            <img src={Image2} alt="imagem" />
            <h3>Profissionais especializados</h3>
          </Card>
          <Card>
            <img src={Image3} alt="imagem" />
            <h3>Transparência do início ao fim</h3>
          </Card>
          <Card>
            <img src={Image4} alt="imagem" />
            <h3>Foco total em resolver o seu problema</h3>
          </Card>
        </Cards>
      </Content>
    </Container>
  );
};

export default Benefits;
